// To keep the log a manageable length, please limit the number of releases listed here to 5.
// If you are adding a 6th entry, please remove the oldest entry so that the total remains at 5.

const VersionLog = `

### Version 5.14.0 - October XX, 2025

- Completely removed Out of Market from GEM.
  - If a center is selected from the drop down on the intro step, a distance of 120+ miles will no longer switch the center.
  - OOM is no longer an option within the center dropdown on the intro step under any circumstances.
  - The OOM disposition no longer exists.
  - Patient note tags related to OOM no longer exist.
  - The booking step will no longer be blocked due to Out of Market reasons.

---

### Version 5.13.1 - November 03, 2025

- Minor changes to the Medical questions regarding radiation and cancer treatment.

---

### Version 5.13.0 - October 16, 2025

- Increased the upper limit for non-candidate BMI from 42 to 48. Valid patient BMI is now 18 - 48.
- New medical step questions!
  - The medical step has many new questions to help better identify candidates.
  - Some questions are multi-part, and require first questions to answer "yes" before later questions should be asked.
  - Some questions add new Guest and Appointment note tags. You can expect new tags for "Radiation", "Diabetic" (replaces A1C), and "Defibrillator".
  - The pacemaker question has a new "Yes/No" answer style, and you should click the correct one based on the patient's answer.
  - Some new combinations of medical questions now disqualify the patient from being a candidate.
---

### Version 5.12.1 - July 16, 2025

- Updated the Medical Escalation disposition link to the new Medical Escalation app.

---

### Version 5.12.0 - July 01, 2025

- Fix an assortment of booking failures that can occur when making changes in the ribbon and then moving to the booking step.
- Phone Number is now required before proceeding to the booking step.
- Added the missing label for the 'Distance to Center' field on the Intro step.

---

### Version 5.11.0 - June 16, 2025

- Inbound Phone or SMS Contacts will not update the Mobile Phone property of existing Patients.
- Webform and Chat will prompt the user if the selected Patient name, phone, or email differs from the Contact.
- Fix bug where clicking on an existing Patient on the Search step prevents typing input into the Phone search field.

`;

export default VersionLog;
